export function smoothScroll(_sel) {
    _sel.addEventListener('click', function (e) {
        e.preventDefault();

        // Close navigation if it's open (adjust class names as per your site)
        if (document.querySelector('.site-navigation__navicon--active') && document.body.classList.contains('site-navigation--open')) {
            document.querySelector('.site-navigation__navicon').click();
        }

        // Remove active state from submenus if present
        if (e.target.parentNode.parentNode) {
            e.target.parentNode.parentNode.classList.remove('site-navigation__sub-menu--active');
        }

        if (e.target.parentNode.parentNode.parentNode) {
            e.target.parentNode.parentNode.parentNode.querySelector('a').classList.remove('site-navigation__menu-item--active');
        }

        // Handle anchor links within the same page
        if (e.target.href.includes('#') && document.getElementById(e.target.href.split('#')[1])) {
            const targetId = e.target.href.split('#')[1];
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                // Get the header height from CSS variable
                const headerHeight = parseInt(getComputedStyle(document.documentElement)
                    .getPropertyValue('--header-height').trim(), 10) || 0;

                const offsetTop = targetElement.offsetTop - headerHeight;

                window.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth'
                });

                // Update the URL without causing a page jump
                history.pushState(null, null, `#${targetId}`);
            }
        } else {
            // Fallback to regular link navigation
            window.location.href = e.target.href;
        }
    });
}
